import React, { useEffect, useState } from "react"
import {
  Modal,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap"

import InputMask from "react-input-mask"

const ModalFornecedores = ({
  isOpen,
  toggle,
  FornecedorEditavel,
  onFornecedorAlterado,
}) => {
  const [Nome, setNome] = useState("")
  const [CPF_CNPJ, setCPF_CNPJ] = useState("")
  const [Responsavel, setResponsavel] = useState("")
  const [Telefone, setTelefone] = useState("")
  const [Endereco, setEndereco] = useState("")

  useEffect(() => {
    resetForm()
    if (FornecedorEditavel) {
      setNome(FornecedorEditavel.Nome)
      setCPF_CNPJ(FornecedorEditavel.CPF_CNPJ)
      setResponsavel(FornecedorEditavel.Responsavel)
      setTelefone(FornecedorEditavel.Telefone)
      setEndereco(FornecedorEditavel.Endereco)
    } else {
    }
  }, [FornecedorEditavel])

  useEffect(() => {
    if (!isOpen) {
      resetForm()
    }
  }, [isOpen])

  const resetForm = () => {
    setNome("")
    setCPF_CNPJ("")
    setResponsavel("")
    setTelefone("")
    setEndereco("")
  }

  const handleSubmit = event => {
    event.preventDefault()
    const fornecedorData = {
      Fornecedores: {
        Nome,
        CPF_CNPJ,
        Responsavel,
        Telefone,
        Endereco,
      },
    }

    if (FornecedorEditavel) {
      updateFornecedor(fornecedorData)
    } else {
      addFornecedor(fornecedorData)
    }
  }

  const addFornecedor = fornecedorData => {
    try {
      fetch(`${process.env.REACT_APP_API}/fornecedores`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(fornecedorData),
      })
        .then(response => response.json())
        .then(response => {
          onFornecedorAlterado(`Fornecedor adicionado com sucesso!`, "success")
          toggle()
        })
    } catch (error) {
      onFornecedorAlterado(`Erro ao adicionar fornecedor: ${error}`, "error")
    }
  }

  const updateFornecedor = fornecedorData => {
    try {
      fetch(
        `${process.env.REACT_APP_API}/fornecedores/${FornecedorEditavel.FornecedorID}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(fornecedorData),
        },
      )
        .then(response => response.json())
        .then(response => {
          onFornecedorAlterado(`Fornecedor alterado com sucesso!`, "success")
          toggle()
        })
    } catch (error) {
      onFornecedorAlterado(`Erro ao alterar fornecedor: ${error}`, "error")
    }
  }

  const deleteFornecedor = () => {
    try {
      fetch(
        `${process.env.REACT_APP_API}/fornecedores/${FornecedorEditavel.FornecedorID}`,
        {
          method: "DELETE",
        },
      )
        .then(response => response.json())
        .then(response => {
          onFornecedorAlterado(`Fornecedor excluído com sucesso!`, "success")
          toggle()
        })
    } catch (error) {
      onFornecedorAlterado(`Erro ao excluir fornecedor: ${error}`, "error")
    }
  }

  const handleCpfCnpjChange = e => {
    let value = e.target.value
    value = value.replace(/\D/g, "") // Remove tudo o que não é dígito
    if (value.length <= 11) {
      // CPF
      value = value.replace(/(\d{3})(\d)/, "$1.$2")
      value = value.replace(/(\d{3})(\d)/, "$1.$2")
      value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    } else {
      // CNPJ
      value = value.replace(/^(\d{2})(\d)/, "$1.$2")
      value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      value = value.replace(/\.(\d{3})(\d)/, ".$1/$2")
      value = value.replace(/(\d{4})(\d)/, "$1-$2")
    }
    setCPF_CNPJ(value)
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <div className="modal-header">
        <h5 className="modal-title mt-0">Adicionar/Editar Fornecedor</h5>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={toggle}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <Form onSubmit={handleSubmit}>
        <div className="modal-body">
          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label for="Nome">Nome</Label>
                <Input
                  type="text"
                  name="Nome"
                  id="Nome"
                  placeholder="Digite o nome do fornecedor"
                  value={Nome}
                  onChange={e => setNome(e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="CPF_CNPJ">CPF/CNPJ</Label>
                <InputMask
                  onChange={handleCpfCnpjChange}
                  placeholder="Digite o CPF ou CNPJ"
                  value={CPF_CNPJ}
                  className="form-control"
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Responsavel">Responsável</Label>
                <Input
                  type="text"
                  name="Responsavel"
                  id="Responsavel"
                  placeholder="Nome do responsável"
                  value={Responsavel}
                  onChange={e => setResponsavel(e.target.value)}
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="Telefone">Telefone</Label>
                <InputMask
                  mask="(99) 99999-9999"
                  value={Telefone}
                  onChange={e => setTelefone(e.target.value)}
                  className="form-control"
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="Endereço">Endereço</Label>
                <Input
                  type="text"
                  name="Endereco"
                  id="Endereco"
                  placeholder="Digite o endereço"
                  value={Endereco}
                  onChange={e => setEndereco(e.target.value)}
                />
              </FormGroup>
            </Col>

            {/* <Col md={6}>
              <FormGroup>
                <Label for="Email">E-mail</Label>
                <Input
                  type="email"
                  name="Email"
                  id="Email"
                  placeholder="Digite o e-mail"
                  value={Email}
                  onChange={e => setEmail(e.target.value)}
                />
              </FormGroup>
            </Col> */}
          </Row>
        </div>
        <div className="modal-footer">
          <Button type="button" color="secondary" onClick={toggle}>
            Cancelar
          </Button>
          <Button type="submit" color="primary">
            Salvar
          </Button>
          {FornecedorEditavel && (
            <Button
              type="button"
              color="danger"
              onClick={() => deleteFornecedor()}
            >
              Excluir
            </Button>
          )}
        </div>
      </Form>
    </Modal>
  )
}

export default ModalFornecedores
